'use client';

import { signIn } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

export default function LoginPage() {
  const router = useRouter();
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError('');
    setLoading(true);
    const form = new FormData(e.currentTarget);
    try {
      const result = await signIn('credentials', {
        email:    form.get('email'),
        password: form.get('password'),
        redirect: false,
      });
      if (result?.error) {
        setError('Invalid email or password.');
      } else {
        router.push('/');
      }
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ padding: '40px 24px' }}>
      <div
        className="w-full glass"
        style={{ maxWidth: 380, padding: '40px 36px' }}
      >
        {/* Logo */}
        <div style={{ marginBottom: 32 }}>
          <div className="flex items-baseline gap-2" style={{ marginBottom: 6 }}>
            <span style={{ color: '#F3F5F7', fontWeight: 700, fontSize: 22, letterSpacing: '-0.03em' }}>ATN</span>
            <span style={{ color: '#697586', fontWeight: 400, fontSize: 16 }}>Portal</span>
          </div>
          <p style={{ color: '#697586', fontSize: 13 }}>Sign in to your account</p>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#9AA5B5', marginBottom: 6, letterSpacing: '0.02em' }}>
              EMAIL
            </label>
            <input
              name="email"
              type="email"
              required
              autoComplete="email"
              className="glass-input"
            />
          </div>

          <div>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#9AA5B5', marginBottom: 6, letterSpacing: '0.02em' }}>
              PASSWORD
            </label>
            <input
              name="password"
              type="password"
              required
              autoComplete="current-password"
              className="glass-input"
            />
          </div>

          {error && (
            <p style={{ fontSize: 13, color: '#E05A5A', margin: 0 }}>{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            className="btn-red"
            style={{ marginTop: 8, width: '100%' }}
          >
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
